module.exports = __webpack_public_path__ + "assets/img/12a80be058d6fd3eef9d391692397b32.png";